"use client";

// ../../core/system-rsc/src/utils.ts
import { forwardRef as baseForwardRef } from "react";
function forwardRef(component) {
  return baseForwardRef(component);
}

// ../../core/system/src/provider-context.ts
import { createContext } from "@kirvanobr/react-utils";
var [ProviderContext, useProviderContext] = createContext({
  name: "ProviderContext",
  strict: false
});

export {
  forwardRef,
  useProviderContext
};
